import {useState,useRef,forwardRef,useImperativeHandle,memo} from 'react';
import api from '../../../services/api';
import FormProcesso from './FormProcesso';
import FormMontagem from './FormMontagem';
import {InfoBox,InfoRow} from './InfoBox';
import {CATS_FABRICACAO,CATS_MONTAGEM,CLASSES_ORDER,TIPO_MONTAGEM_MAP,UNIDADES,CATEGORIAS} from '../constants';

const fmt  = v => parseFloat(v||0).toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2});
const fmt4 = v => parseFloat(v||0).toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:4});

// Inputs isolados para nao perder foco
function CampoTexto({label, value, onChange, tipo='text'}){
  return(
    <div className='form-group'>
      <label className='form-label'>{label}</label>
      <input
        className='form-input'
        type={tipo}
        value={value||''}
        onChange={e=>onChange(e.target.value)}
        onClick={e=>e.stopPropagation()}
      />
    </div>
  );
}

function CampoSelect({label, value, onChange, opts}){
  return(
    <div className='form-group'>
      <label className='form-label'>{label}</label>
      <select
        className='form-select'
        value={value||''}
        onChange={e=>onChange(e.target.value)}
        onClick={e=>e.stopPropagation()}
      >
        {opts.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}
      </select>
    </div>
  );
}

const FormEdicao = memo(forwardRef(function FormEdicao({p, onSalvo}, ref){
  const fab  = CATS_FABRICACAO.includes(p.categoria);
  const mont = CATS_MONTAGEM.includes(p.categoria) && p.categoria !== 'PRODUTO_FINAL';
  const isPF = p.categoria === 'PRODUTO_FINAL';

  const [form, setForm] = useState({
    codigo:         p.codigo,
    nome:           p.nome,
    categoria:      p.categoria,
    classe:         p.classe||'',
    tipo:           p.tipo||'',
    origem:         p.origem||'FABRICADO',
    unidade:        p.unidade,
    preco_custo:    p.preco_custo,
    estoque:        p.estoque,
    estoque_minimo: p.estoque_minimo,
    ncm:            p.ncm||'',
    cfop:           p.cfop||'',
    csosn:          p.csosn||'',
    ean:            p.ean||'',
    descricao:      p.descricao||'',
  });
  const set = (f,v) => setForm(prev=>({...prev,[f]:v}));

  const tipoMontagemAtual = TIPO_MONTAGEM_MAP.find(
    t=>t.v!==''&&t.categoria===form.categoria&&(t.tipo===''||t.tipo===(form.tipo||''))&&(t.classe===''||t.classe===(form.classe||''))
  )?.v||'';

  const setTipoMontagem = v => {
    const t = TIPO_MONTAGEM_MAP.find(x=>x.v===v);
    if(t) setForm(f=>({...f,categoria:t.categoria,tipo:t.tipo,classe:t.classe}));
  };

  const salvar = async () => {
    try{
      const classeAuto = (form.categoria==='SEMIACABADO'&&['ROLDANA','ROLDANA_GANCHO'].includes(form.tipo)) ? 'ROLDANAS' : form.classe;
      const origemAuto = ['SEMIACABADO','MONTAGEM_VARAL','MONTAGEM_KIT','MONTAGEM_MV'].includes(form.categoria) ? 'FABRICADO' : form.origem;
      const dadosSalvar = {...form, classe:classeAuto, origem:origemAuto}; if(['MONTAGEM_VARAL','MONTAGEM_KIT','MONTAGEM_MV','SEMIACABADO','PRODUTO_FINAL','INJECAO_PLASTICA','CORTE_BARRA_ALU','TRANCAGEM_CORDA'].includes(form.categoria)) delete dadosSalvar.preco_custo; await api.patch('/produtos/produtos/'+p.id+'/', dadosSalvar);
      onSalvo();
    }catch(e){
      const msg = e.response?.data ? JSON.stringify(e.response.data) : 'Erro ao salvar.';
      alert(msg);
    }
  };

  useImperativeHandle(ref, ()=>({salvar}));

  return(
    <div onClick={e=>e.stopPropagation()}>
      <div style={{display:'grid',gridTemplateColumns:'160px 2fr 200px 140px',gap:8,marginBottom:8}}>
        <CampoTexto label='Codigo' value={form.codigo} onChange={v=>set('codigo',v)}/>
        <CampoTexto label='Nome'   value={form.nome}   onChange={v=>set('nome',v)}/>
        {mont
          ? <CampoSelect label='Tipo de montagem' value={tipoMontagemAtual} onChange={setTipoMontagem} opts={TIPO_MONTAGEM_MAP}/>
          : (isPF||fab)
            ? <CampoSelect label='Categoria' value={form.categoria} onChange={v=>set('categoria',v)} opts={CATEGORIAS.map(c=>({v:c.key,l:c.label}))}/>
            : null
        }
        <CampoSelect label='Unidade' value={form.unidade} onChange={v=>set('unidade',v)} opts={UNIDADES}/>
      </div>
      {isPF&&(
        <>
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:8,marginBottom:8}}>
            <CampoSelect label='Classe' value={form.classe} onChange={v=>set('classe',v)}
              opts={[{v:'',l:'-- Selecione --'},...CLASSES_ORDER.filter(c=>c.key!=='').map(c=>({v:c.key,l:c.label}))]}/>
            <CampoSelect label='Origem' value={form.origem} onChange={v=>set('origem',v)}
              opts={[{v:'COMPRADO',l:'Comprado'},{v:'FABRICADO',l:'Fabricado'},{v:'AMBOS',l:'Comprado e Fabricado'}]}/>
            <CampoTexto label='Custo (R$)' value={form.preco_custo} onChange={v=>set('preco_custo',v)} tipo='number'/>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:8,marginBottom:8}}>
            <CampoTexto label='NCM'       value={form.ncm}   onChange={v=>set('ncm',v)}/>
            <CampoTexto label='CFOP'      value={form.cfop}  onChange={v=>set('cfop',v)}/>
            <CampoTexto label='CSOSN/CST' value={form.csosn} onChange={v=>set('csosn',v)}/>
            <CampoTexto label='EAN'       value={form.ean}   onChange={v=>set('ean',v)}/>
          </div>
        </>
      )}
    </div>
  );
}));

export default function DropdownProduto({p,onExcluir,onDuplicar,onAtualizar,atualizarProduto,maquinas,funcionarios,produtos}){
  const fab   = CATS_FABRICACAO.includes(p.categoria);
  const mont  = CATS_MONTAGEM.includes(p.categoria);
  const isAlu = p.tipo==='ALUMINIO';
  const isFio = p.tipo==='FIO';

  const formRef     = useRef(null);
  const processoRef = useRef(null);
  const montagemRef = useRef(null);

  const [editandoId,    setEditandoId]    = useState(null);
  const [salvandoPreco, setSalvandoPreco] = useState(false);
  const [verHistorico,  setVerHistorico]  = useState(false);
  const [salvandoDados, setSalvandoDados] = useState(false);

  const custoComp = (p.composicao||[]).reduce((s,c)=>s+(parseFloat(c.custo_linha)||0),0);
  const custoProc = (p.processos||[]).reduce((s,pr)=>s+parseFloat(pr.custo_mao_obra||0)+parseFloat(pr.custo_maquina||0)+parseFloat(pr.custo_outros||0),0);

  const salvarPreco = async(cId,preco) => {
    setSalvandoPreco(true);
    try{
      await api.patch('/produtos/produtos/'+cId+'/',{preco_custo:preco});
      setEditandoId(null);
      onAtualizar();
    }catch{alert('Erro ao salvar preco.');}
    finally{setSalvandoPreco(false);}
  };

  const salvarTudo = async () => {
    setSalvandoDados(true);
    try{
      if(formRef.current)     await formRef.current.salvar();
      if(fab&&processoRef.current)  await processoRef.current.salvar();
      if(mont&&montagemRef.current) await montagemRef.current.salvar();
    }catch(e){
      alert(e.response?.data ? JSON.stringify(e.response.data) : "Erro ao salvar: "+e.message);
    }finally{setSalvandoDados(false);}
  };

  return(
    <div className='produto-dropdown'>
      <FormEdicao key={p.id} ref={formRef} p={p} onSalvo={onAtualizar}/>

      {!fab&&!mont&&(
        <div className='dropdown-row' style={{marginBottom:16}}>
          {isAlu&&parseFloat(p.comprimento_barra)>0&&(
            <InfoBox titulo='Especificacoes da Barra'>
              <InfoRow label='Comprimento'    value={fmt4(p.comprimento_barra)+' m'}/>
              <InfoRow label='Peso por metro' value={fmt4(p.kg_metro)+' kg/m'}/>
              <InfoRow label='Peso total'     value={fmt4(parseFloat(p.comprimento_barra)*parseFloat(p.kg_metro))+' kg'}/>
            </InfoBox>
          )}
          {isFio&&parseFloat(p.grama_metro)>0&&(
            <InfoBox titulo='Especificacoes do Fio'>
              <InfoRow label='Grama por metro' value={fmt4(p.grama_metro)+' g/m'}/>
              <InfoRow label='Diametro'        value={fmt4(p.diametro_mm)+' mm'}/>
            </InfoBox>
          )}
          {(p.composicao||[]).length>0&&(
            <InfoBox titulo='Composicao'>
              {p.composicao.map(c=>(
                <InfoRow key={c.id} label={c.componente_nome}>
                  {editandoId===c.id?(
                    <span className='dropdown-value'>
                      <input type='number' className='form-input' style={{width:80,padding:'1px 5px',fontSize:12}}
                        defaultValue={parseFloat(c.componente_preco||0).toFixed(4)}
                        id={'preco-'+c.id} autoFocus/>
                      <button className='btn btn-primary' style={{padding:'1px 7px',fontSize:11}}
                        disabled={salvandoPreco}
                        onClick={e=>{e.stopPropagation();salvarPreco(c.componente,document.getElementById('preco-'+c.id).value);}}>
                        OK
                      </button>
                      <button className='btn btn-secondary' style={{padding:'1px 7px',fontSize:11}}
                        onClick={e=>{e.stopPropagation();setEditandoId(null);}}>
                        x
                      </button>
                    </span>
                  ):(
                    <span className='dropdown-value'>
                      {fmt4(c.quantidade)} {c.unidade} x{' '}
                      <span style={{color:'var(--z-blue)',cursor:'pointer',borderBottom:'1px dashed var(--z-blue)'}}
                        onClick={e=>{e.stopPropagation();setEditandoId(c.id);}}>
                        R$ {fmt4(c.componente_preco)}
                      </span>
                      {' '}= <strong>R$ {fmt(c.custo_linha)}</strong>
                    </span>
                  )}
                </InfoRow>
              ))}
              <div className='dropdown-total'><span>Custo materiais</span><span>R$ {fmt(custoComp)}</span></div>
            </InfoBox>
          )}
          {(p.fornecedores||[]).length>0&&!(p.composicao||[]).length&&(
            <InfoBox titulo='Fornecedores'>
              {p.fornecedores.map(f=>(
                <InfoRow key={f.id} label={f.fornecedor_nome}>
                  <span className='dropdown-value'>
                    R$ {fmt4(f.preco)}/{p.unidade}
                    <button className='btn btn-primary' style={{padding:'1px 8px',fontSize:11}}
                      onClick={e=>{e.stopPropagation();api.patch('/produtos/produtos/'+p.id+'/',{preco_custo:f.preco}).then(()=>onAtualizar());}}>
                      Usar
                    </button>
                  </span>
                </InfoRow>
              ))}
            </InfoBox>
          )}
          {verHistorico&&(
            <InfoBox titulo='Historico de Precos'>
              {(p.historico_precos||[]).length===0
                ? <div className='dropdown-label'>Sem historico.</div>
                : p.historico_precos.slice(0,8).map(h=>(
                    <InfoRow key={h.id} label={new Date(h.criado_em).toLocaleDateString('pt-BR')}>
                      <span className='historico-row'>
                        <span className='historico-antigo'>R$ {fmt4(h.preco_antigo)}</span>
                        <i className='ti ti-arrow-right' style={{fontSize:11}}/>
                        <span className='historico-novo'>R$ {fmt4(h.preco_novo)}</span>
                      </span>
                    </InfoRow>
                  ))
              }
            </InfoBox>
          )}
        </div>
      )}

      {fab&&(
        <div style={{marginBottom:16}}>
          <FormProcesso ref={processoRef} produto={p} maquinas={maquinas} funcionarios={funcionarios} allProdutos={produtos} onSalvo={()=>onAtualizar()}/>
        </div>
      )}
      {mont&&(
        <div style={{marginBottom:16}}>
          <FormMontagem ref={montagemRef} produto={p} allProdutos={produtos} funcionarios={funcionarios} onAtualizar={()=>atualizarProduto(p.id)}/>
        </div>
      )}

      {!mont&&(custoComp+custoProc)>0&&(
        <div className='produto-custo-total'>
          <span>CUSTO TOTAL CALCULADO</span><span>R$ {fmt(custoComp+custoProc)}</span>
        </div>
      )}

      <div className='produto-dropdown-acoes'>
        <button className='btn btn-primary' disabled={salvandoDados} onClick={e=>{e.stopPropagation();salvarTudo();}}>
          <i className='ti ti-check'/> {salvandoDados?'Salvando...':'Salvar'}
        </button>
        <button className='btn btn-danger' onClick={e=>{e.stopPropagation();onExcluir(p.id);}}>
          <i className='ti ti-trash'/> Excluir
        </button>
        {onDuplicar&&(
          <button className='btn btn-secondary' onClick={e=>{e.stopPropagation();onDuplicar(p);}}>
            <i className='ti ti-copy'/> Duplicar
          </button>
        )}
        {!fab&&(
          <button className={'btn btn-secondary'+(verHistorico?' aba-ativa':'')}
            onClick={e=>{e.stopPropagation();setVerHistorico(v=>!v);}}>
            <i className='ti ti-history'/> Historico{(p.historico_precos||[]).length>0&&' ('+(p.historico_precos.length)+')'}
          </button>
        )}
        <span className='spacer'>{p.codigo} | {p.categoria_display}</span>
      </div>
    </div>
  );
}
